/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Muhammad Siddique",
  title: "Hi all, I'm Muhammad Siddique",
  subTitle: emoji(
    "A passionate Full Stack Software Developer 🚀 having an experience of building Web and Mobile applications with JavaScript / Reactjs / Nodejs / Nextjs / MongoDB and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1VlWRGobgiLrSNnOPpn0IxZSOusVNp8hk/view?usp=drive_link", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/Siddique145/",
  linkedin: "https://www.linkedin.com/in/muhammad-siddique-jagirani/",
  gmail: "muhammadsiddique14344@gmail.com",
  gitlab: "https://gitlab.com/users/Muhammad-Siddique145",
  facebook: "https://www.facebook.com/profile.php?id=61550358442636",
  medium: "https://medium.com/@muhammadsiddiquejagirani",
  stackoverflow: "https://stackoverflow.com/users/26364863/muhammad-siddique",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications"
    ),
    emoji("⚡ Progressive Web and Desktop Applications with best Performance"),
    emoji("⚡ Integration of third party services such as Firebase/ MongoDB")
  ],

  softwareSkills: [
    {
      skillName: "HTML5",
      fontAwesomeClassname: "fab devicon-html5-plain colored" // HTML5 orange
    },
    {
      skillName: "CSS3",
      fontAwesomeClassname: "fab devicon-css3-plain colored" // CSS3 blue
    },
    {
      skillName: "Sass",
      fontAwesomeClassname: "fab devicon-sass-original colored" // Sass pink
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab devicon-javascript-plain colored" // JavaScript yellow
    },
    {
      skillName: "TypeScript",
      fontAwesomeClassname: "fab devicon-typescript-plain colored" // TypeScript blue
    },
    {
      skillName: "React",
      fontAwesomeClassname: "fab devicon-react-original colored" // React blue
    },
    {
      skillName: "Next.js",
      fontAwesomeClassname: "fab devicon-nextjs-plain colored" // Next.js
    },
    {
      skillName: "React Native",
      fontAwesomeClassname: "fab devicon-react-original colored" // React blue
    },
    {
      skillName: "Electron",
      fontAwesomeClassname: "fab devicon-electron-original colored" // Electron
    },
    {
      skillName: "Node.js",
      fontAwesomeClassname: "fab devicon-nodejs-plain colored" // Node.js green
    },
    {
      skillName: "Express",
      fontAwesomeClassname: "fab devicon-express-original colored" // Express
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab devicon-npm-original-wordmark colored" // npm red
    },
    {
      skillName: "MongoDB",
      fontAwesomeClassname: "fab devicon-mongodb-plain colored" // MongoDB green
    },
    {
      skillName: "Firebase",
      fontAwesomeClassname: "fab devicon-firebase-plain colored" // Firebase yellow/orange
    },
    {
      skillName: "Supabase",
      fontAwesomeClassname: "fab devicon-supabase-plain colored" // Supabase green
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "SMIT (Saylani Mass It Training)",
      logo: require("./assets/images/SMITLogo.png"),
      subHeader: "Hybrid Web and APP Development",
      duration: "December 2023 - December 2024 ",
      desc: "Participated and was an active Part of the Class",
      descBullets: [
        "I have fully focused on my learning with the best Practises"
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "75%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: true // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Web Developer",
      company: "Facebook",
      companylogo: require("./assets/images/facebookLogo.png"),
      date: "June 2023 – Present",
      desc: "Best Response and Attraction towards to the Clients",
      descBullets: [
        "Web Developer",
        "Creating Charming and Attractive Websites"
      ]
    },
    {
      role: "Front-End Web Developer",
      company: "ZS Design",
      companylogo: require("./assets/images/ZSlogo.png"),
      date: "May 2023 – May 2024",
      desc: "I have Worked with my full Efforts and Collaboration",
      descBullets: [
        "Front-End Developer",
        "Creating Charming and Attractive Websites"
      ]
    },
    {
      role: "Mern Stack Developer ",
      company: "Upwork",
      companylogo: require("./assets/images/upwork.png"),
      date: "Jan 2023 – Present",
      desc: "Creating Best Websites with complete requirements",
      descBullets: [
        "Mern Stack Developer",
        "Providing Best Solutions To my Clients"
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/Poslogo.png"),
      projectName: "Pharmacy Point Of Sale",
      projectDesc: "An Point of Sale With Complete CRUD",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://mypos-ruby.vercel.app/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/quiz Logo.png"),
      projectName: "Live Quiz Web App",
      projectDesc: "Full Realtime Quiz Web App",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://muhammadsiddiquequiz.vercel.app/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/bookstorelogo.jpg"),
      projectName: "Noorani Book Store",
      projectDesc: "An Online Book Store",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://siddique145.github.io/Noorani-Book-Depot/"
        }
      ]
    },
    {
      image: require("./assets/images/newslogo.jpeg"),
      projectName: "News App",
      projectDesc: "An All Pakistan Current News App ",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://siddique145.github.io/All-Pakistan-News-App/"
        }
      ]
    },
    {
      image: require("./assets/images/Weatherlogo.jpeg"),
      projectName: "Weather App",
      projectDesc: "All World Current Weather App ",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://siddique145.github.io/Weather-webapp/"
        }
      ]
    },
    {
      image: require("./assets/images/tasklogo.jpg"),
      projectName: "Task App",
      projectDesc: "Task App , All the Task List of a Day",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://siddique145.github.io/Task-App-Firebase/"
        }
      ]
    },
    {
      image: require("./assets/images/Ecommercelogo.jpeg"),
      projectName: "Ecommerce Website",
      projectDesc: "An Online Shopping",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://ecommercecom.vercel.app/"
        }
      ]
    },
    {
      image: require("./assets/images/Marsksheetlogo.jpeg"),
      projectName: "Student Marksheet",
      projectDesc: "Student Marks Management",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://marksheet-nine.vercel.app/"
        }
      ]
    },
    {
      image: require("./assets/images/MS QR.png"),
      projectName: "Qr Code Generator",
      projectDesc: "Make your Qr Code",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://qrcodegenerator-chi-six.vercel.app/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/Apilogo.jpeg"),
      projectName: "Products Api Fetched",
      projectDesc: "Api Fetched Products With the Cart Functionality ",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://react-api-serach-web.vercel.app/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆"),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title:
        "Microsoft Learn Student Ambassadors — Front-end Web Development Hackathon Certificate",
      subtitle:
        "Awarded for attending and successfully completing the Front-end Web Development Hackathon hosted by Microsoft Learn Student Ambassador, Hussnain Ahmad.",
      image: require("./assets/images/microsoftcertificate.png"),
      imageAlt: "Hackthon"
    },
    {
      title: "Google Cloud Career Readiness Program — Cloud Computing Marathon",
      subtitle:
        "Certified for actively participating and completing the Google Cloud Marathon Program — focused on practical learning, cloud computing skills, and hands-on labs.",
      image: require("./assets/images/googlecertificate.png"),
      imageAlt: "Google Certification"
    },

    {
      title: "Frontend Development Internship — Certificate of Completion",
      subtitle:
        "Awarded for successfully completing a 3-month Internship as a Frontend Developer at TechNetCloud under the mentorship of Aliyan Shaikh (CEO, TechNetCloud).",
      image: require("./assets/images/technetcloudinternship.png"),
      imageAlt: "PWA Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/1mJ7rgY_isBoXzJEdqTHY3YxPPsADD9zB/view?usp=drive_link"
        },
        {
          name: "Offer Letter",
          url: "https://drive.google.com/file/d/1AJVwmsQofk0boBZp2eaytw57-KJ83sOT/view?usp=drive_link"
        }
      ]
    },
{
  title: "🏆 Hacktoberfest 2025 Winner",
  subtitle:
    "Awarded as a Hacktoberfest 2025 winner for contributing to the open-source community, receiving an official T-shirt from the USA, a tree planted by Treenation, a certificate, and digital badges.",
  image: require("./assets/images/hacktoberfestcombinedimage.png"),
  imageAlt: "Hacktoberfest 2025 T-Shirt & Badge",
  footerLink: [
    {
      name: "Hacktoberfest T-Shirt",
      url: "https://drive.google.com/file/d/1aIDr4GoK1ef6d058JHJUYK65V4v8PQqD/view?usp=sharing"
    },
    {
      name: "Tree Certification",
      url: "https://drive.google.com/file/d/1nlL51O_vgN_l0RFFJCJgXa8mSr1zTQv7/view?usp=sharing"
    },
    {
      name: "My Achievement",
      url: "https://drive.google.com/file/d/1V-dhRLKR3BMhBWvdt-LvF_WHoH6vwjvc/view?usp=sharing"
    }
  ]
}
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://medium.com/@muhammadsiddiquejagirani?source=rss-ac147433bb92------2",
      title: "Top Websites Every Developer Must Bookmark",
      description:
        "Whether you are a frontend ninja, backend warrior, or full-stack wizard, these websites are your ultimate companions for coding, debugging, learning, and growing!"
    },
    {
      url: "https://medium.com/@muhammadsiddiquejagirani/ai-and-web-development-29ed21dfa778?source=rss-ac147433bb92------2",
      title: "AI and Web Development",
      description:
        "Artificial Intelligence (AI) is rapidly transforming web development, enhancing user experience, streamlining processes, and enabling smarter websites. Let's take a quick look at how AI is revolutionizing web development."
    }
  ],
  display: true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+92-3107508919",
  email_address: "muhammadsiddique14344@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
